/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import Icon from "@mui/material/Icon";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost } from "../../../api";

import {formatDate, DownloadFile} from "../../../utils"

const Tables = (props) => {

  const endPoint = "/document/tvs";

  const { user } = useAuthContext();

  const columns = [
      { Header: "Serial Number", accessor: "serial", align: "center" },
      /*{ Header: "Model Name", accessor: "model", align: "center" },*/
      { Header: "Download", accessor: "document_download", align: "left" },
    ]

  const [ rows, setRows ] = useState([]);

  const [ TableData, setTableData ] = useState([]);

  const [ FiltredModels, setFiltredModels ] = useState([]);

  const [ FiltredSerial, setFiltredSerial ] = useState("");

  const [ refrechedData, setRefrechedData ] = useState(true);

  const handleSerialFilter = (serial) => {
    const model = serial.substring(4,13);
    const lot = serial.substring(13,16);

    if (model.length == 9 && lot.length == 3){
      setFiltredModels(TableData.filter((row) => row.model == model && String(row.lot) == lot));
    }else{
      setFiltredModels(TableData);
    }
  }

  const handleDownload = (url, document_id) => {
    // Mark it as downloaded
    if (user.role === "user"){
      const response = httpGet(process.env.REACT_APP_URL_BASE + "/document/download/" + document_id);
    }

    window.open(url, '_blank');
  }

  useEffect(() => {
    const fetchData = async () => {
        const response = await httpGet(process.env.REACT_APP_URL_BASE + endPoint);
        
        if (response.status != 200){
            return
        }

        setTableData(await response.json());

        setRefrechedData(!refrechedData);
    }

    if (refrechedData) {
      fetchData();
    }
  }, [refrechedData])

  useEffect(() => {
    setFiltredModels(TableData);
  }, [TableData])

  useEffect(() => {
      setRows(FiltredModels.map((row) => {
          // cache model / lot in used models, so we show the name once

          const name = row.model
          const lot = row.lot.toString().padStart(3, '0');

          const download = row.document_url == null ? "" : <MDButton searchValue={row.document_name} variant="outlined" color="success" size="small" onClick={(e) => handleDownload(row.document_url, row.document_id)}>
                  <Icon fontSize="large">download</Icon> {row.document_name}
                </MDButton> 

          return {
            serial: <>XXXX<span style={{color: "red"}}>{row.model}</span><span style={{color: "green"}}>{lot}</span>LXXXXX</>,
            model: name,

            document_download: download
          }
        }))
      
  }, [FiltredModels])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  List of Television's Documents
                </MDTypography>
              </MDBox>

              <MDBox mt={4} mx={2}>
                <MDTypography variant="label" color="text">
                  Serial Number :
                </MDTypography>
                <MDInput sx={{width: "100%"}} placeholder="Write your serial number to filter..." type="text" onChange={(e) => {
                  handleSerialFilter(e.target.value);
                }} />
              </MDBox>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
